import { EComparisonStatus } from '../../repositories/newbuilding-search/entities/get_newbuildings_for_serp/NewbuildingForSerpItem';
import { IApplicationState } from '../../types/redux';
import { getNewbuildingByIdSelector } from './getNewbuildingByIdSelector';

export const getNewbuildingComparisonStatusSelector =
  (newbuildingId: number) =>
  (state: IApplicationState): EComparisonStatus | null | undefined => {
    const nb = getNewbuildingByIdSelector(newbuildingId)(state);

    if (nb) {
      return nb.comparisonStatus;
    }

    // ЖК промо-сниппета приходит в отдельном контракте и не раскладывается в state.newbuildings.byId,
    // поэтому для него статус сравнения читаем из стейта промо-сниппета — иначе кнопка сравнения
    // у промо-сниппета не отрисуется.
    const promoSnippetNewbuilding = state.offersData.newbuildingPromoSnippet?.newbuilding;

    if (promoSnippetNewbuilding?.id === newbuildingId) {
      return promoSnippetNewbuilding.comparisonStatus;
    }

    return undefined;
  };
